import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import {
  deleteTemporaryFilters,
  getL1SheetProperty,
  getL2SheetProperty,
  getWorkbookProperty,
  removeLevel2Properties,
  setFiltersToOtherSheets,
  setLevel2Properties,
  setWorkbookProperty,
  updateLevel2Properties,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { useSelector, useDispatch } from "react-redux";
import { lineTransformData } from "../../VizComponents/Utils/lineTransformData";
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import {
  getSheetControls,
  setSheetControls,
} from "../../../features/reduxworkbook/WorkbookControllingSlice";
import { sortData } from "../Utils/SortData";
import { formatNumber } from "../Utils/FormatNumbers";
import { CustomTooltip } from "../Custom/CustomTooltipContent";
import {
  adjustOpacity,
  dispatchSortValues,
  removeTotalKeyValuePair,
} from "../Utils/ChartsFunctions";
import { CustomLegend } from "../Custom/CustomLegendContent";
import { CalculateAction, handleClicked } from "../../actions/Action";
import { nanoid } from "@reduxjs/toolkit";
import { handleHeirarchy } from "../Utils/HandleHeirarchy";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

const LineChartComp = ({
  Data,
  Sheetid,
  rowKeys: rawRowKeys,
  valueKeys,
  toolTipKeys = [],
  groupByKeys: rawGroupByKeys,
  sortProperties,
  isAnimataionOff,
  vizType,
  filters: filterArray,
  dataSourceID,
}) => {
  const { roles } = useAuth();
  console.log(roles);
  console.log(toolTipKeys);

  let timer;
  const containerRef = useRef(null);
  const reduxActiveIndex = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "activeIndex" })
  );
  const reduxClickedCaption = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "clickedCaption" })
  );
  console.log(reduxActiveIndex);
  console.log(reduxClickedCaption);

  const [pointSize, setpointSize] = useState(1);

  const [clickedCaption, setClickedCaption] = useState(
    (reduxClickedCaption !== undefined && reduxClickedCaption) || []
  );
  console.log(clickedCaption);
  const [activeIndex, setActiveIndex] = useState(reduxActiveIndex || []);
  const [hoverIndex, setHoverIndex] = useState(null);
  console.log(activeIndex);
  // console.log(hoverIndex);
  const [clickTimeoutState, setClickTimeoutState] = useState(null);

  const groupByKeys = rawGroupByKeys.map((item) => item.responseKey);
  console.log(groupByKeys);

  const SufixPrefix = { ...valueKeys.map((item) => item.numberFormat) };
  console.log(SufixPrefix);
  console.log(valueKeys);

  const [longestLabelWidth, setLongestLabelWidth] = useState(0);
  const leftMargin = Math.ceil(longestLabelWidth) + 10;
  const dispatch = useDispatch();
  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const getOnClickProperties = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "onClick");
  });
  console.log(leftMargin);

  const getOnDoubleClickProperties = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "actions", "onDoubleClick")
  );
  console.log(getOnDoubleClickProperties);
  const sheetsArray = useSelector((state) =>
    getWorkbookProperty(state, "sheets")
  );

  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || [];
  const workbookId =
    useSelector((state) => getWorkbookProperty(state, "_id")) || [];
  const workbookType =
    useSelector((state) => getWorkbookProperty(state, "type")) || [];
  const {
    colorSchemeid,
    isLabelVisible,
    labelPosition,
    labelFontSize,
    labelFontColor,
    labelRotate,
    lineTypes,
    isLegendVisible,
    legendAlign,
    legendVerticalAlign,
    legendLayout,
    isGridVisible,
    isTransposeVisible,
    // pointSize,
  } = customizationObject;
  useEffect(() => {
    // Initialize selectedIcon with reactIcon from customizationObject

    setpointSize(customizationObject.pointSize);
  }, [customizationObject, pointSize]);
  useEffect(() => {
    if (containerRef.current) {
      const updateSizes = () => {
        const containerWidth = containerRef.current.offsetWidth;
        const containerHeight = containerRef.current.offsetHeight;
        console.log(containerHeight);
        console.log(containerWidth);

        const maxSize = Math.min(containerWidth, containerHeight) / 2 - 10;

        const newPointSize = Math.min(
          customizationObject.pointSize,
          maxSize * 0.1
        );
        setpointSize(newPointSize > 2 ? newPointSize : 2);
      };

      updateSizes();
      window.addEventListener("resize", updateSizes);

      return () => window.removeEventListener("resize", updateSizes);
    }
  }, [customizationObject, pointSize]);
  //add usememo
  const {
    table: transformedData,
    lines: uniqueRowKeys,
    transformedTooltipKeys,
  } = useMemo(() => {
    return lineTransformData(
      Data,
      rawRowKeys,
      rawGroupByKeys,
      valueKeys,
      toolTipKeys
    );
  }, [Data]);
  console.log(rawRowKeys);
  console.log(valueKeys);

  const newArray =
    uniqueRowKeys.length > 0 && valueKeys.length > 0
      ? [
          ...uniqueRowKeys,
          ...valueKeys.map((obj) => `Total ${obj.responseKey}`),
        ]
      : [];
  if (uniqueRowKeys.length > 0) {
    dispatchSortValues({
      newArray,
      dispatch,
      setSheetControls,
      Sheetid,
    });
  }

  const sortedData =
    sortProperties.length > 0 && rawRowKeys.length > 0
      ? sortData({
          transformedData,
          sortProperties,
          rawRowKeys,
          rawGroupByKeys,
          requiredArray: rawGroupByKeys,
        })
      : transformedData;
  console.log(
    sortProperties.length > 0 && rawRowKeys.length > 0
      ? "data is sorted on frontend side"
      : "sorted data is coming from backend side"
  );

  const TotalKeysArray =
    valueKeys.length > 0
      ? [...valueKeys.map((obj) => `Total ${obj.responseKey}`)]
      : [];
  // console.log(TotalKeysArray);
  const isTotalKeyPairValueRemoved = true;
  const { arrayWithOutTotals, maxValue } = removeTotalKeyValuePair({
    sortedData,
    TotalKeysArray,
    isTotalKeyPairValueRemoved,
  });
  const paddedMaxValue = maxValue * 1.2;
  // console.log(paddedMaxValue);

  const nanoId = nanoid();
  const navigate = useNavigate();

  const handleClickEvent = (data, index, event, buttonEvent) => {
    // Check if event is undefined, fallback to window.event if necessary
    const newEvent = event || window.event;
    console.log(getOnClickProperties?.action);
    if (!getOnClickProperties?.action && !getOnDoubleClickProperties?.action) {
      handleClicked({
        data: uniqueRowKeys,
        index,
        event: newEvent,
        requiredArray: rawRowKeys,
        hoverIndex,
        dispatch,
        deleteTemporaryFilters,
        setFiltersToOtherSheets,
        Sheetid,
        clickedCaption,
        setClickedCaption,
        activeIndex,
        setActiveIndex,
        vizType,
        rawRowKeys,
        dataSourceID,
      });
    } else {
      if (
        getOnClickProperties?.action === "Hierarchy" &&
        valueKeys.length > 0 &&
        rawRowKeys[0] &&
        groupByKeys[0]
      ) {
        const rowCurrentValue = rawRowKeys[0]["rename"];
        const groupCurrentValue = rawGroupByKeys[0]["rename"];
        const partBeforePipeLine = uniqueRowKeys[hoverIndex]
          ? uniqueRowKeys[hoverIndex].split("|")[0]
          : undefined;
        console.log(partBeforePipeLine, data.activeLabel);
        let groupFilterItemIs,
          rowFilterItemIs,
          isGroupHierarchyLastItemExist,
          isRowHierarchyLastItemExist,
          groupIsExpandable,
          rowIsExpandable;
        groupFilterItemIs = {
          columnName: rawGroupByKeys[0].columnName,
          dataType: rawGroupByKeys[0].dataType,
          uuid: rawGroupByKeys[0].uuid,
          rename: rawGroupByKeys[0].rename,
          sourceSheetId: Sheetid,
          nanoId: nanoId,
          selectedFilterValues: [data.activeLabel],
          selectedOperator: "IN",
          filterType: "temporary",
          format: null,
          dataSourceID,
        };
        rowFilterItemIs = {
          columnName: rawRowKeys[0].columnName,
          dataType: rawRowKeys[0].dataType,
          uuid: rawRowKeys[0].uuid,
          rename: rawRowKeys[0].rename,
          sourceSheetId: Sheetid,
          nanoId: nanoId,
          selectedFilterValues: [partBeforePipeLine],
          selectedOperator: "IN",
          filterType: "temporary",
          format: null,
          dataSourceID,
        };

        const rowHierarchy = rowCurrentValue
          ? hierarchy.find((item) =>
              item.hierarchyArray.find((arr) => arr.rename === rowCurrentValue)
            )
          : null;
        const groupHierarchy = groupCurrentValue
          ? hierarchy.find((item) =>
              item.hierarchyArray.find(
                (arr) => arr.rename === groupCurrentValue
              )
            )
          : null;
        rowIsExpandable =
          rowHierarchy !== undefined && rowHierarchy !== null ? true : false;
        groupIsExpandable =
          groupHierarchy !== undefined && groupHierarchy !== null
            ? true
            : false;
        isGroupHierarchyLastItemExist =
          groupHierarchy !== undefined &&
          groupHierarchy.hierarchyArray[
            groupHierarchy.hierarchyArray.length - 1
          ]["rename"] === groupCurrentValue;
        isRowHierarchyLastItemExist =
          rowHierarchy !== undefined &&
          rowHierarchy.hierarchyArray[rowHierarchy.hierarchyArray.length - 1][
            "rename"
          ] === rowCurrentValue;
        if (clickTimeoutState) {
          clearTimeout(clickTimeoutState);
          setClickTimeoutState(null);
          console.log("double clicked");
          handleHeirarchy({
            headerId: groupCurrentValue,
            foundHierachy: {},
            requiredArray: [],
            dispatch: dispatch,
            functionToAddAndUpdate: updateLevel2Properties,
            functionToRemove: removeLevel2Properties,
            Sheetid: Sheetid,
            vizType: vizType,
            functionWillBe: "replaceItemWithNextItem",
            groupHierarchy,
            rowHierarchy,
            rowCurrentValue,
            groupCurrentValue,
            groupIsExpandable,
            rowIsExpandable,
          });
          console.log(groupFilterItemIs);
          console.log(rowFilterItemIs);

          if (groupIsExpandable && !isGroupHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: groupFilterItemIs,
                itemInArray: true,
              })
            );
          }
          if (rowIsExpandable && !isRowHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: rowFilterItemIs,
                itemInArray: true,
              })
            );
          }
        } else {
          const timeout = setTimeout(() => {
            setClickTimeoutState(null);
            console.log("single clicked");
            handleHeirarchy({
              headerId: groupCurrentValue,
              foundHierachy: {},
              requiredArray: [],
              dispatch: dispatch,
              functionToAddAndUpdate: updateLevel2Properties,
              functionToRemove: removeLevel2Properties,
              Sheetid: Sheetid,
              vizType: vizType,
              functionWillBe: "replaceItemWithpreviousItem",
              groupHierarchy,
              rowHierarchy,
              rowCurrentValue,
              groupCurrentValue,
              groupIsExpandable,
              rowIsExpandable,
            });
            const findRemoveAbleItem = (
              hierarchyArray,
              currentIndex,
              filterArray
            ) => {
              console.log(currentIndex);
              const heirarchyPreivousItemIs =
                hierarchyArray[currentIndex - 1].uuid;
              console.log(heirarchyPreivousItemIs);
              const filterItemIs = filterArray.find(
                (filterItem) => filterItem.uuid === heirarchyPreivousItemIs
              );
              console.log(filterItemIs);
              if (filterItemIs) {
                return filterItemIs;
              }
              return undefined;
            };

            const groupCurrentIndex =
              groupHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === groupCurrentValue
              ) ?? -1;

            const rowCurrentIndex =
              rowHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === rowCurrentValue
              ) ?? -1;

            const groupRemoveAbleItemIs =
              groupCurrentIndex > 0
                ? findRemoveAbleItem(
                    groupHierarchy.hierarchyArray,
                    groupCurrentIndex,
                    filterArray
                  )
                : undefined;

            const rowRemoveAbleItemIs =
              rowCurrentIndex > 0
                ? findRemoveAbleItem(
                    rowHierarchy.hierarchyArray,
                    rowCurrentIndex,
                    filterArray
                  )
                : undefined;

            console.log(groupRemoveAbleItemIs);
            console.log(rowRemoveAbleItemIs);

            if (groupIsExpandable && groupRemoveAbleItemIs !== undefined) {
              dispatch(
                removeLevel2Properties({
                  reduxKey: "filters",
                  parentKey: "query",
                  value: groupRemoveAbleItemIs,
                  Sheetid,
                  itemInArray: true,
                })
              );
            }
            if (rowIsExpandable && rowRemoveAbleItemIs !== undefined) {
              dispatch(
                removeLevel2Properties({
                  reduxKey: "filters",
                  parentKey: "query",
                  value: rowRemoveAbleItemIs,
                  Sheetid,
                  itemInArray: true,
                })
              );
            }
          }, 250);
          setClickTimeoutState(timeout);
        }
      } else {
        console.log(timer);
        if (rawRowKeys.length > 0 && rawGroupByKeys.length > 0) {
          if (timer) {
            //it is a second click
            clearTimeout(timer);
            timer = null;
            console.log("double");
            CalculateAction({
              data: uniqueRowKeys,
              index,
              event: newEvent,
              requiredArray: rawRowKeys,
              hoverIndex,
              dispatch,
              deleteTemporaryFilters,
              setFiltersToOtherSheets,
              Sheetid,
              clickedCaption,
              setClickedCaption,
              activeIndex,
              setActiveIndex,
              vizType,
              rawRowKeys,
              actionsProperty: getOnDoubleClickProperties,
              setWorkbookProperty,
              workbookId,
              workbookType,
              workbookId,
              workbookType,
              navigate,
              dataSourceID,
              sheetsArray,
            });
          } else {
            timer = setTimeout(() => {
              console.log("single");
              CalculateAction({
                data: uniqueRowKeys,
                index,
                event: newEvent,
                requiredArray: rawRowKeys,
                hoverIndex,
                dispatch,
                deleteTemporaryFilters,
                setFiltersToOtherSheets,
                Sheetid,
                clickedCaption,
                setClickedCaption,
                activeIndex,
                setActiveIndex,
                vizType,
                rawRowKeys,
                actionsProperty: getOnClickProperties,
                setWorkbookProperty,
                workbookId,
                workbookType,
                navigate,
                dataSourceID,
                sheetsArray,
              });
              timer = null;
            }, 300);
            console.log(timer);
          }
        } else {
          console.error(
            `${rawRowKeys.length} should be greater than zero ${rawGroupByKeys.length} should be greater than zero`
          );
        }
      }
    }
  };

  useEffect(() => {
    console.log(Sheetid);
    dispatch(
      setSheetControls({
        Sheetid: Sheetid,
        controls: {
          activeIndex,
          clickedCaption,
        },
      })
    );
  }, [activeIndex, clickedCaption]);
  // Get color scheme
  const colorScheme = getColourSchemeByID(colorSchemeid);
  const COLORS = colorScheme?.colors;

  const tickFormatter = (tick) => {
    console.log(SufixPrefix.mode === "Manual");
    console.log(!isTransposeVisible);

    if (typeof tick === "number" || typeof tick === "string") {
      const formattedTick =
        typeof tick === "string" ? tick : formatNumber(tick, SufixPrefix);

      // Create a temporary canvas to measure the text width
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = "12px Arial"; // Use the same font as the chart
      const textWidth = context.measureText(formattedTick).width;

      // Update the longest label width if this tick is longer
      // Update the longest label width if this tick is longer
      if (isTransposeVisible) {
        setLongestLabelWidth(
          (prevWidth) => Math.max(prevWidth, textWidth) - 20
        );
      } else {
        if (SufixPrefix.mode === "Manual") {
          setLongestLabelWidth(
            (prevWidth) => Math.max(prevWidth, textWidth) - 20
          );
        } else {
          setLongestLabelWidth(
            (prevWidth) => Math.max(prevWidth, textWidth) - 10
          );
        }
      }

      return formattedTick;
    }
    return tick;
  };

  const custLegend = ({ payload, layout = "horizontal", align = "left" }) => {
    // Map align prop to Tailwind CSS classes for horizontal layouts
    const getAlignmentClass = (align) => {
      switch (align) {
        case "left":
          return "justify-start";
        case "center":
          return "justify-center";
        case "right":
          return "justify-end";
        default:
          return "justify-start"; // Default alignment is left
      }
    };

    // Define dynamic spacing based on layout (more space for vertical)
    const getSpacingClass = () => {
      return layout === "vertical" ? "mt-3" : "mb-4";
    };

    return (
      <div
        className={`custom-legend flex text-sm text-[#353535] ${
          layout === "horizontal" ? "flex-wrap " : "flex-col pl-16"
        } ${getAlignmentClass(align)} ${getSpacingClass()}`} // Dynamic spacing based on layout
        style={{ marginBottom: layout === "horizontal" ? "9px" : "0" }} // Adjust spacing between legend and chart for horizontal layout
      >
        {payload.map((entry, index) => (
          <div
            key={`item-${index}`}
            className={`legend-item flex items-center ${
              layout === "horizontal" ? "mx-1 my-2" : "mb-4"
            }`} // Adjust margin for horizontal and vertical layouts
          >
            <div
              className={`legend-icon ${
                layout === "horizontal" ? "mx-2" : "my-0"
              }`} // Adjust spacing for legend icons
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: entry.color,
              }}
            ></div>
            <span>{entry.value}</span>
          </div>
        ))}
      </div>
    );
  };

  const CustomLab = (props) => {
    const {
      x,
      y,
      value,
      fontSize,
      fill,
      angle,
      position,
      formatter,
      dataKey,
      fontWeight,
      stroke,
      strokeWidth,
    } = props;

    // Format the value using the formatter function
    const formattedValue = formatter ? formatter(value) : value;

    // Adjust positioning based on the provided position
    let adjustedX = x;
    let adjustedY = y;
    switch (position) {
      case "top":
        adjustedY = y - 8; // Adjust for top positioning
        break;
      case "center":
        adjustedY = y + 10; // Adjust for bottom positioning
        break;
      case "bottom":
        adjustedY = y + 20;
        break;

      case "left":
        adjustedX = x - 10; // Adjust for left positioning
        break;

      // case "center":
      //   // Default center positioning, no change needed
      //   break;
      default:
        // In case position is not recognized
        adjustedX = x;
        adjustedY = y;
        break;
    }

    return (
      <text
        x={adjustedX}
        y={adjustedY}
        dy={-5} // Adjust vertical positioning
        fontSize={fontSize}
        fill={fill}
        fontWeight={fontWeight}
        stroke={stroke} // Add stroke (border) color
        strokeWidth={strokeWidth} // Add stroke width
        transform={`rotate(${angle}, ${x}, ${y})`} // Apply rotation around (x, y)
      >
        {formattedValue}
      </text>
    );
  };

  const handleLineMouseEnter = (lineIndex) => {
    setHoverIndex(lineIndex);
  };

  const handleLineMouseLeave = () => {
    setHoverIndex(null);
  };

  return (
    <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
      <ResponsiveContainer
        width="100%"
        height="100%"
        className="flex items-center justify-center "
      >
        <LineChart
          data={arrayWithOutTotals}
          layout={isTransposeVisible ? "vertical" : "horizontal"}
          // margin={{ right: 30 }}
          margin={
            isTransposeVisible
              ? { top: 30, left: leftMargin, right: 50 } // Adjust top margin to create space
              : { right: 70, top: 20, left: leftMargin } // Adjust top margin to create space
          }
          onClick={(data, event) => {
            hoverIndex !== null && handleClickEvent(data, hoverIndex, event);
          }}
        >
          {isGridVisible && <CartesianGrid strokeDasharray="3 3" />}
          {isTransposeVisible ? (
            <>
              <XAxis
                type="number"
                tick={{ fill: "#909497" }}
                tickFormatter={isTransposeVisible ? tickFormatter : null}
              />
              <YAxis
                type="category"
                dataKey={groupByKeys[0]}
                tick={{ fill: "#909497" }}
                tickFormatter={tickFormatter}
              />
            </>
          ) : (
            <>
              <XAxis
                dataKey={groupByKeys[0]}
                tick={{ fill: "#909497" }}
                tickFormatter={isTransposeVisible ? tickFormatter : null}
              />
              <YAxis
                tick={{ fill: "#909497 " }}
                // dataKey={groupByKeys[0]}
                allowDataOverflow
                domain={[0, paddedMaxValue]}
                tickFormatter={tickFormatter}
              />
            </>
          )}
          <Tooltip
            content={
              <CustomTooltip
                // toolTipKeys={toolTipKeys}
                toolTipArray={toolTipKeys}
                SufixPrefix={SufixPrefix}
                colorSchemeid={colorSchemeid}
                currentLineIndex={hoverIndex}
                rowKeys={rawRowKeys}
                headerKeys={uniqueRowKeys}
                columnKeys={rawGroupByKeys}
                valueKeys={valueKeys}
                tooltipKeys={transformedTooltipKeys}
                chartType={"line"}
              />
            }
          />
          {isLegendVisible && (
            <Legend
              align={legendAlign.value}
              verticalAlign={legendVerticalAlign.value}
              layout={legendLayout.value}
              iconType="square"
              content={
                <CustomLegend
                  {...{
                    align: legendAlign.value,
                    verticalAlign: legendVerticalAlign.value,
                    layout: legendLayout.value,
                    valueKeys,
                  }}
                />
              }
            />
          )}
          {uniqueRowKeys.map((items, index) => {
            console.log(items);
            console.log(valueKeys);

            const calculateLineID = () => {
              const arrayOfString = items.split("|");
              return arrayOfString[arrayOfString.length - 1];
            };

            const measureValue = calculateLineID();
            console.log(measureValue);

            const calculatedlineId = calculateLineID ? measureValue : null;

            const { numberFormat } = valueKeys.find(
              (valueObject) => valueObject.responseKey === measureValue
            ) || { mode: "Auto" };

            const isActive =
              activeIndex.length > 0 && !activeIndex.includes(index);
            const baseColor = COLORS[index % COLORS.length];
            const strokeColor =
              activeIndex.length === 0
                ? COLORS[index % COLORS.length]
                : isActive
                ? adjustOpacity(baseColor) // Reduce opacity for inactive lines
                : baseColor;

            // const strokeColor =
            //   activeIndex.length === 0
            //     ? COLORS[index % COLORS.length]
            //     : isActive
            //       ? adjustOpacity(COLORS[index % COLORS.length])
            //       : COLORS[index % COLORS.length];

            return (
              <Line
                key={index}
                type={lineTypes?.value}
                dataKey={items}
                stackId={calculatedlineId}
                stroke={strokeColor} // Apply calculated color
                strokeWidth={hoverIndex === index ? 3 : 2}
                dot={
                  (containerRef.current &&
                    containerRef.current.offsetWidth <= 600) ||
                  hoverIndex !== index
                    ? false // Hide dots if the container is too small or the line is not hovered
                    : {
                        r: hoverIndex === index ? pointSize + 2 : pointSize, // Increase size on hover
                        onMouseEnter: () => handleLineMouseEnter(index), // Handle hover
                        onMouseLeave: handleLineMouseLeave, // Handle hover end
                      }
                }
                isAnimationActive={isAnimataionOff}
                onMouseEnter={() => handleLineMouseEnter(index)}
                onMouseLeave={handleLineMouseLeave}
              >
                {isLabelVisible && (
                  <LabelList
                    content={
                      <CustomLab
                        fontSize={labelFontSize}
                        fill={labelFontColor}
                        angle={labelRotate}
                        formatter={(value) => formatNumber(value, numberFormat)}
                        position={labelPosition.value}
                        dataKey={items}
                        fontWeight="bold"
                        stroke="white"
                        strokeWidth={0.2}
                      />
                    }
                  />
                )}
              </Line>
            );
          })}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartComp;
